import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled, { css } from 'styled-components';

import { getMedia, getMediaMin, percent } from '../../../helpers/layout';
import Television from '../Television/Television';

export const Content = styled.div`
    display: block;
    align-self: center;
    position: relative;
    z-index: 10;
    max-width: ${percent(1920, 830)}vw;

    @media only screen and ${getMedia('desktop', 'tablet')} {
        max-width: ${percent(1366, 615)}vw;
    }

    @media only screen and ${getMedia('tablet', 'phone')} {
        max-width: ${percent(768, 515)}vw;
        display: block;
    }

    @media only screen and ${getMedia('phone')} {
        max-width: none;
        display: block;
    }
`;

export const Slogan = styled.span`
    ${FONTS.H2};
    color: ${COLORS.TextPrimary};
    display: block;

    @media only screen and ${getMedia('desktop', 'tablet')} {
        ${FONTS.H3};
    }

    @media only screen and ${getMedia('tablet', 'phone')} {
        ${FONTS.XXL};
    }

    @media only screen and ${getMedia('phone')} {
        ${FONTS.S};
    }
`;

export const Title = styled.h1`
    ${FONTS.H0};
    color: ${COLORS.TextPrimary};
    margin-top: 4px;
    margin-bottom: 0;
    display: block;

    @media only screen and ${getMedia('desktop', 'tablet')} {
        ${FONTS.H1};
    }

    @media only screen and ${getMedia('tablet', 'phone')} {
        ${FONTS.H1};
    }

    @media only screen and ${getMedia('phone')} {
        ${FONTS.H2};
        margin-top: 10px;
    }
`;

export const Text = styled.p`
    ${FONTS.L};
    color: ${COLORS.TextPrimary};
    margin-top: 36px;
    display: block;
    max-width: 75%;

    @media only screen and ${getMedia('desktop', 'tablet')} {
        ${FONTS.S};
        margin-top: 28px;
    }

    @media only screen and ${getMedia('tablet', 'phone')} {
        ${FONTS.S};
        margin-top: 26px;
        max-width: none;
    }

    @media only screen and ${getMedia('phone')} {
        ${FONTS.S};
        margin-top: 24px;
        max-width: 93%;
    }
`;

export const Footnote = styled(Text)`
    ${FONTS.S};

    @media only screen and ${getMedia('desktop')} {
        ${FONTS.XXS};
    }
`;

export const ButtonWrapper = styled.div`
    display: inline-flex;
    margin-top: 42px;

    @media only screen and ${getMedia('desktop', 'tablet')} {
        margin-top: 37px;
    }

    @media only screen and ${getMedia('tablet', 'phone')} {
        margin-top: 32px;
    }

    @media only screen and ${getMedia('phone')} {
        margin-top: 38px;
    }

    & > * {
        @media only screen and ${getMedia('phone')} {
            min-width: 210px;
        }
    }
`;

export const TelevisionStyled = styled(Television)`
    position: absolute;
    bottom: -5.4vw;
    right: 0;
    z-index: 10;
    transform-origin: center;
    transform: scale(0.866) translateX(45.07%);
    will-change: transform;

    @media only screen and ${getMedia('desktop', 'tablet')} {
        bottom: -5.5vw;
        transform: scale(0.87) translateX(41.9%);
    }

    @media only screen and ${getMedia('tablet', 'phone')} {
        bottom: -8.1vw;
        transform: translateX(39%);
    }

    @media only screen and ${getMedia('phone')} {
        bottom: -18.1vw;
        transform: translateX(51.2%);
    }
`;

export const Section = styled.section`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 127px 114px 96px;
    background: linear-gradient(0deg, #E5E8EC 46.74%, #E5E7EC 98.96%);
    overflow: hidden;
    display: flex;
    will-change: opacity;

    @media only screen and ${getMedia('desktop', 'tablet')} {
        padding: 140px 79px 18px;
    }

    @media only screen and ${getMedia('tablet', 'phone')} {
        display: block;
        position: relative;
        padding: 138px 62px ${percent(768, 459)}vw;
        height: auto;
    }

    @media only screen and ${getMedia('phone')} {
        display: block;
        position: relative;
        height: auto;
        padding: 108px 20px ${percent(320, 408)}vw;
    }

    @media only screen and ${getMediaMin('tablet')} {
        ${({ isActive, from, to }) => {
            // Переход на второй слайд
            if (!isActive && to === 'advantage') {
                return css`
                    opacity: 0;
                    transition: opacity 0s ease-out 1.4s;

                    ${TelevisionStyled} {
                        transform: scale(0.866) translateX(64%) translateX(-58.1vw);
                        transition: transform 0.8s cubic-bezier(.58,.06,.31,.79);

                        @media only screen and ${getMedia('desktop', 'tablet')} {
                            transform: scale(0.87) translateX(66%) translateX(-57.8vw);
                        }
                    }

                    ${Slogan},
                    ${Title},
                    ${Text},
                    ${ButtonWrapper} {
                        opacity: 0;
                        transform: translateY(45px);
                        transition: opacity 0.3s ease-out, transform 0.3s ease-out;
                    }
                `;
            } else if (!isActive && to === 'archive') { // Переход на третий слайд
                return css`
                    opacity: 0;
                    transition: opacity 0s ease-out 1.4s;

                    ${TelevisionStyled} {
                        transform: translateX(64%) translateX(-74.9vw) translateY(-1.3%);
                        transition: transform 0.8s cubic-bezier(.58,.06,.31,.79);

                        @media only screen and ${getMedia('desktop', 'tablet')} {
                            transform: translateX(64%) translateX(-73.5vw) translateY(-2.1%);
                        }
                    }

                    ${Slogan},
                    ${Title},
                    ${Text},
                    ${ButtonWrapper} {
                        opacity: 0;
                        transform: translateY(45px);
                        transition: opacity 0.3s ease-out, transform 0.3s ease-out;
                    }
                `;
            } else if (isActive && (from === 'advantage' || from === 'archive')) { // Приход с второго или третего экрана
                return css`
                    transition: opacity 0.4s ease-out 0.8s;
                    opacity: 1;
                    z-index: 10;

                    ${Slogan},
                    ${Title},
                    ${Text},
                    ${ButtonWrapper} {
                        opacity: 1;
                        transform: translateY(0);
                    }

                    ${Slogan},
                    ${Title} {
                        transition: opacity 0.3s ease-out 0.8s, transform 0.3s ease-out 0.8s;
                    }

                    ${Text},
                    ${ButtonWrapper} {
                        transition: opacity 0.3s ease-out 1.1s, transform 0.3s ease-out 1.1s;
                    }
                `;
            } else if (isActive) {
                return css`
                    transition: opacity 0.4s ease-out;
                    opacity: 1;
                    z-index: 10;

                    ${Slogan},
                    ${Title},
                    ${Text},
                    ${ButtonWrapper} {
                        opacity: 1;
                        transform: translateY(0);
                    }

                    ${Slogan},
                    ${Title} {
                        transition: opacity 0.3s ease-out 0.4s, transform 0.3s ease-out 0.4s;
                    }

                    ${Text},
                    ${ButtonWrapper} {
                        transition: opacity 0.3s ease-out 0.7s, transform 0.3s ease-out 0.7s;
                    }
                `;
            } else {
                return css`
                    opacity: 0;
                    transition: opacity 0.4s ease-out 0.4s;

                    ${Slogan},
                    ${Title},
                    ${Text},
                    ${ButtonWrapper} {
                        opacity: 0;
                        transform: translateY(45px);
                        transition: opacity 0.3s ease-out 0.4s, transform 0.3s ease-out 0.4s;
                    }
                `;
            }
        }}
    }

    &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: ${percent(1920, 466)}vw;
        background: linear-gradient(0.06deg, #F2F6FF 0.25%, #F3F7FF 17.55%, #EEF2FC 24.7%, #E1E7F3 34.71%, #DBE1EE 40.99%, #DBE1EF 44.41%, #E2E6F1 54.67%, rgba(224, 226, 230, 0.5) 80.08%, rgba(230, 232, 236, 0.5) 102.12%);
        z-index: 1;

        @media only screen and ${getMedia('tablet', 'phone')} {
            height: ${percent(768, 330)}vw;
        }

        @media only screen and ${getMedia('phone')} {
            height: ${percent(320, 258)}vw;
        }
    }
`;
